import React from "react";
import "./SelectionSummaryDisplay.css";

/**
 * Parse persisted selection summary for display.
 * Supports new multiline blocks ("\n\n") and legacy single-line "A: B · C: D" format.
 */
export function parseSelectionSummaryBlocks(summary) {
  if (summary == null || String(summary).trim() === "") return [];
  const s = String(summary).trim();

  if (s.includes(" · ")) {
    return s
      .split(" · ")
      .map(parseLegacySegment)
      .filter((b) => b && (b.label || b.value));
  }

  if (s.includes("\n")) {
    return s
      .split(/\n\n+/)
      .map((b) => b.trim())
      .filter(Boolean)
      .map((block) => {
        const nl = block.indexOf("\n");
        if (nl === -1) return { label: "", value: block };
        return {
          label: block.slice(0, nl).trim(),
          value: block.slice(nl + 1).trim(),
        };
      });
  }

  const m = s.match(/^(.+?):\s*(.+)$/);
  if (m) {
    return [{ label: m[1].trim(), value: m[2].trim() }];
  }

  return [{ label: null, value: s }];
}

function parseLegacySegment(seg) {
  const t = String(seg).trim();
  const m = t.match(/^(.+?):\s*(.+)$/);
  if (m) return { label: m[1].trim(), value: m[2].trim() };
  return { label: null, value: t };
}

/**
 * Renders cart/checkout/order selection: title line then value line per group.
 */
export default function SelectionSummaryDisplay({ summary, className = "", hiddenLabels = [] }) {
  const hiddenLabelSet = new Set(
    (hiddenLabels || []).map((label) => String(label || "").trim().toLowerCase()).filter(Boolean)
  );
  const blocks = parseSelectionSummaryBlocks(summary).filter((block) => {
    if (!block.label || hiddenLabelSet.size === 0) return true;
    return !hiddenLabelSet.has(block.label.trim().toLowerCase());
  });
  if (blocks.length === 0) return null;

  return (
    <div className={`selection-summary-display ${className}`.trim()}>
      {blocks.map((b, i) => (
        <div key={i} className="selection-summary-block">
          {b.label ? (
            <div className="selection-summary-label">{b.label}</div>
          ) : null}
          <div className="selection-summary-value">{b.value}</div>
        </div>
      ))}
    </div>
  );
}
